<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div *ngIf="!$hasMissingRequiredInParams"
          class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="edit" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_edit_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
              <ng-template 
                toolbarToolDef="separator1" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <div class="tool-separator"></div>
                </ng-container>
              </ng-template>
              <ng-template 
                toolbarToolDef="create_location" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_create_location_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized && !$hasMissingRequiredInParams">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
        </div>

        <div class="widgets">
          <div *ngIf="!widgets.locations_empty_by_count_widget.hidden && !widgets.locations_empty_by_count_widget.removed" class="widget-container">
            <Locations-locations_empty_by_count_widget
            #$widgets_locations_empty_by_count_widget 
              [warehouseId]="$widgets_locations_empty_by_count_widget_inParams_warehouseId"
            ($refreshEvent)="refresh(false, false, '$widgets_locations_empty_by_count_widget')"
            >
            </Locations-locations_empty_by_count_widget>
          </div>
          <div *ngIf="!widgets.locations_by_count_widget.hidden && !widgets.locations_by_count_widget.removed" class="widget-container">
            <Locations-locations_by_count_widget
            #$widgets_locations_by_count_widget 
              [warehouseId]="$widgets_locations_by_count_widget_inParams_warehouseId"
            ($refreshEvent)="refresh(false, false, '$widgets_locations_by_count_widget')"
            >
            </Locations-locations_by_count_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.locations.hasTabToShow" class="tab" data-cy="tab-locations">
              <h2 [className]="tabs.locations.active? 'active': ''" (click)="tabs.locations.activate()">{{tabs.locations.title}}</h2>
            </div>
            <div *ngIf="tabs.locations_detail.hasTabToShow" class="tab" data-cy="tab-locations_detail">
              <h2 [className]="tabs.locations_detail.active? 'active': ''" (click)="tabs.locations_detail.activate()">{{tabs.locations_detail.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory.hasTabToShow" class="tab" data-cy="tab-inventory">
              <h2 [className]="tabs.inventory.active? 'active': ''" (click)="tabs.inventory.activate()">{{tabs.inventory.title}}</h2>
            </div>
            <div *ngIf="tabs.replenishments.hasTabToShow" class="tab" data-cy="tab-replenishments">
              <h2 [className]="tabs.replenishments.active? 'active': ''" (click)="tabs.replenishments.activate()">{{tabs.replenishments.title}}</h2>
            </div>
            <div *ngIf="tabs.primary_picks.hasTabToShow" class="tab" data-cy="tab-primary_picks">
              <h2 [className]="tabs.primary_picks.active? 'active': ''" (click)="tabs.primary_picks.activate()">{{tabs.primary_picks.title}}</h2>
            </div>
            <div *ngIf="tabs.contacts.hasTabToShow" class="tab" data-cy="tab-contacts">
              <h2 [className]="tabs.contacts.active? 'active': ''" (click)="tabs.contacts.activate()">{{tabs.contacts.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-locations_navigational_grid *ngIf="tabs.locations.active"
              #$tabs_locations
              [warehouseId]="$tabs_locations_locations_navigational_grid_inParams_warehouseId"
              ($refreshEvent)="refresh(false, false, '$tabs_locations')">
              </FootprintManager-locations_navigational_grid>
              <FootprintManager-locations_grid *ngIf="tabs.locations_detail.active"
              #$tabs_locations_detail
              [warehouseId]="$tabs_locations_detail_locations_grid_inParams_warehouseId"
              ($refreshEvent)="refresh(false, false, '$tabs_locations_detail')">
              </FootprintManager-locations_grid>
              <FootprintManager-inventory_location_grid *ngIf="tabs.inventory.active"
              #$tabs_inventory
              [warehouseId]="$tabs_inventory_inventory_location_grid_inParams_warehouseId"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory')">
              </FootprintManager-inventory_location_grid>
              <FootprintManager-locations_replenishments_grid *ngIf="tabs.replenishments.active"
              #$tabs_replenishments
              [warehouseIds]="$tabs_replenishments_locations_replenishments_grid_inParams_warehouseIds"
              ($refreshEvent)="refresh(false, false, '$tabs_replenishments')">
              </FootprintManager-locations_replenishments_grid>
              <FootprintManager-primary_picks_grid *ngIf="tabs.primary_picks.active"
              #$tabs_primary_picks
              [warehouse_id]="$tabs_primary_picks_primary_picks_grid_inParams_warehouse_id"
              ($refreshEvent)="refresh(false, false, '$tabs_primary_picks')">
              </FootprintManager-primary_picks_grid>
              <FootprintManager-contact_addresses_grid *ngIf="tabs.contacts.active"
              #$tabs_contacts
              [entity]="$tabs_contacts_contact_addresses_grid_inParams_entity"
              [entityId]="$tabs_contacts_contact_addresses_grid_inParams_entityId"
              ($refreshEvent)="refresh(false, false, '$tabs_contacts')">
              </FootprintManager-contact_addresses_grid>
        </div>

      </ng-container>
      <div *ngIf="$hasMissingRequiredInParams"
           class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>